module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('section', {
    staticClass: "testimonials",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.testimonials.bg + ')'
    }),
    attrs: {
      "id": "testimonials"
    }
  }, [_c('div', {
    staticClass: "testimonials__overlay"
  }), _c('div', {
    staticClass: "testimonials__container"
  }, [_c('swiper', {
    ref: "mySwiper",
    staticClass: "testimonials__swiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.props.acf.testimonials.content), function(slide, i) {
    return _c('swiper-slide', {
      key: i,
      staticClass: "testimonials__slide"
    }, [_c('div', {
      staticClass: "testimonials__col"
    }, [_c('img', {
      staticClass: "testimonials__image",
      attrs: {
        "src": slide.image,
        "alt": "testimonials"
      }
    })]), _c('div', {
      staticClass: "testimonials__col"
    }, [_c('div', {
      staticClass: "testimonials__title"
    }, [_vm._v("- Testimonials -")]), _c('div', {
      staticClass: "testimonials__testimonial",
      domProps: {
        "innerHTML": _vm._s(slide.testimonial)
      }
    })])])
  }), _c('div', {
    staticClass: "testimonials__pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2), _c('div', {
    staticClass: "testimonials__next",
    on: {
      "click": _vm.slideNext
    }
  }, [_c('Icon', {
    attrs: {
      "name": "arrow-circle"
    }
  })], 1), _c('div', {
    staticClass: "testimonials__prev",
    on: {
      "click": _vm.slidePrev
    }
  }, [_c('Icon', {
    attrs: {
      "name": "arrow-circle"
    }
  })], 1)], 1), _c('div', {
    staticClass: "testimonials__appt-btn",
    on: {
      "click": function($event) {
        _vm.showModal(0)
      }
    }
  }, [_c('span', [_vm._v("Request Appointment")])]), _c('div', {
    staticClass: "testimonials__arrow",
    on: {
      "click": function($event) {
        _vm.moveTo(4)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "name": "arrow"
    }
  })], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-040e639b","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/sections/testimonials/testimonials.pug
// module id = 530
// module chunks = 1